import React, { useState, useEffect } from 'react';
import axiosInstance from './backend/axiosInstance';

const PlayersComponent = () => {
    const [playerData, setPlayerData] = useState(null);

    useEffect(() => {
        axiosInstance.get('players/')
            .then((response) => {
                setPlayerData(response.data);
            });
    }, []);

    if (!playerData) {
        return <div>Loading...</div>;
    }

    return (
        <div
            style={{
                padding: "20px",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <table
                style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    maxWidth: "1600px",
                    backgroundColor: "#111827",
                    color: "white",
                }}
            >
                <thead>
                    <tr
                        style={{
                            backgroundColor: "#1f2937",
                        }}
                    >
                        <th style={thStyle}>Player</th>
                        <th style={thStyle}>Matches</th>
                        <th style={thStyle}>Rounds</th>

                        <th style={thStyle}>ACS</th>
                        <th style={thStyle}>KD</th>
                        <th style={thStyle}>ADR</th>
                        <th style={thStyle}>KAST</th>

                        <th style={thStyle}>KPR</th>
                        <th style={thStyle}>APR</th>

                        <th style={thStyle}>FKPR</th>
                        <th style={thStyle}>FDPR</th>

                        <th style={thStyle}>HS%</th>
                    </tr>
                </thead>

                <tbody>
                    {playerData.map((player, index) => (
                        <tr
                            key={index}
                            style={{
                                borderBottom: "1px solid #374151",
                            }}
                        >
                            <td style={tdStyle}>{player.player}</td>
                            <td style={tdStyle}>{player.matches}</td>
                            <td style={tdStyle}>{player.rounds}</td>

                            <td style={tdStyle}>{player.ACS}</td>
                            <td style={tdStyle}>{player.KD}</td>
                            <td style={tdStyle}>{player.ADR}</td>
                            <td style={tdStyle}>
                                {player.KAST ? `${player.KAST}%` : "-"}
                            </td>

                            <td style={tdStyle}>{player.KPR}</td>
                            <td style={tdStyle}>{player.APR}</td>

                            <td style={tdStyle}>{player.FKPR}</td>
                            <td style={tdStyle}>{player.FDPR}</td>

                            <td style={tdStyle}>{player["HS%"]}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const thStyle = {
    padding: "12px",
    textAlign: "center",
    fontWeight: "bold",
};

const tdStyle = {
    padding: "10px",
    textAlign: "center",
};

export default PlayersComponent;